import { websocket_log } from './websocket_log';


const log = {
	websocket_log
}

export {
	log
}